module.exports = __webpack_public_path__ + "static/media/02.bebe6342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/makeup/02.png
// module id = 635
// module chunks = 0